import { Component } from '@angular/core';
import { APPCONFIG } from '../../config';

@Component({
  selector: 'my-app-search-overlay',
  styles: [],
  template: require('./search-overlay.component.html')
})

export class AppSearchOverlayComponent {

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/layout/search-overlay/search-overlay.component.ts